import * as types from './constants';

// Get Version Actions
export const getVersionRequest = () => ({
    type: types.GET_VERSION_REQUEST
});

export const getVersionSuccess = (data) => ({
    type: types.GET_VERSION_SUCCESS,
    payload: data
});

export const getVersionFailure = (error) => ({
    type: types.GET_VERSION_FAILURE,
    payload: error
});

// Update Version Actions
export const updateVersionRequest = (payload) => ({
    type: types.UPDATE_VERSION_REQUEST,
    payload: payload // e.g., { iosVersion, androidVersion, isForceUpdate }
});

export const updateVersionSuccess = (data) => ({
    type: types.UPDATE_VERSION_SUCCESS,
    payload: data
});

export const updateVersionFailure = (error) => ({
    type: types.UPDATE_VERSION_FAILURE,
    payload: error
});